import React, { useState } from 'react';
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { useLocation } from 'react-router-dom';

const PortalLayout = ({ children }) => {
    const [showNav, setShowNav] = useState(true);

    const location = useLocation()

    return (
        <>
            {['/login','/','/forgot-password'].includes(location.pathname.toLowerCase()) ? (
                children
            ) :
                <div className="flex flex-col h-screen overflow-hidden">

                    <div className="flex-shrink-0 w-full">
                        <Topbar showNav={showNav} setShowNav={setShowNav} />
                    </div>

                    <div className="flex flex-1 min-h-0 flex-col md:flex-row relative">
                        {/* Mobile overlay sidebar */}
                        <div className="flex-shrink-0 transition-all duration-[400ms]">
                            <div className="md:hidden">
                                {showNav && (
                                    <div
                                        className="fixed inset-0 z-40 bg-black/40"
                                        onClick={() => setShowNav(false)}
                                    />
                                )}
                                <div className={`fixed z-50 inset-y-0 left-0 w-64 transform bg-black rounded-r-xl shadow-xl transition-transform duration-300 ${showNav ? 'translate-x-0' : '-translate-x-full'}`}>
                                    <Sidebar onClose={() => setShowNav(false)} />
                                </div>
                            </div>
                            {/* Desktop sidebar - fixed width, no horizontal scroll, only vertical scroll if needed */}
                            <div className="hidden md:block flex-shrink-0 w-64 lg:w-72 sticky top-0 self-start max-h-[calc(100vh-80px)] overflow-y-auto overflow-x-hidden no-scrollbar">
                                <Sidebar />
                            </div>
                        </div>

                        {/* Main content - only this area scrolls */}
                        <div className="flex-1 min-h-0 transition-all duration-[400ms] pl-0 md:pl-1 lg:pl-2 flex flex-col overflow-hidden">
                            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden pb-6">{children}</div>
                        </div>
                    </div>
                </div>
            }
        </>

    );
};


export default PortalLayout;

